import React, {Fragment} from "react";
import {connect} from "react-redux";
import {FormattedMessage} from "react-intl";

import {setAIResults, setLookAiImageOpened} from "../../aiActions";


const LookAIPopupGeneratedImages = (props) => {

  const {aiResults, setLookAiImageOpened, setAIResults, isMobile, showLeadOverlay} = props;

  const someResultExist = aiResults.some(res => res.resultImageUrl);

  const onGeneratedImageClick = (aiResult) => {
    if (aiResult) {
      setAIResults(aiResults.map(aiRes => {
        return Object.assign({}, aiRes, {isActive: aiResult.id === aiRes.id});
      }));
    }
    if (someResultExist) {
      setLookAiImageOpened(true);
    }
  }

  const viewAllVisible = !isMobile && someResultExist && (aiResults.filter(res => res.resultImageUrl).length > 1);

  return (
    <div className={viewAllVisible ? "" : "u-mb-1"}>
      <div className="flex u-gap-05 u-mt-05 u-mb-025 look-ai__generated relative">
        {aiResults.map((aiResult, index) => {
          if (index > 2) {
            return null
          }
          const hasResult = aiResult.resultImageUrl;
          const style = hasResult ? {backgroundImage: `url(${aiResult.resultImageUrl})`} : null;
          return (
            <div key={"aiRes" + index}
                 style={style}
                 className={"relative u-w-6 u-h-3 bg-cover bg-center bg-no-repeat bg-lightgray3 u-rounded-025 look-ai__images-panel-result"
                   + (hasResult ? " cursor-pointer" : "")
                   + (hasResult && aiResult.isActive ? " look-ai__images-panel-result--active" : "")}
                 onClick={() => hasResult ? onGeneratedImageClick(aiResult) : null}>
              {hasResult && showLeadOverlay ? (
                <Fragment>
                  <div
                    className="absolute bg-center bg-cover bg-no-repeat u-h-full look-ai__overlay-blur u-rounded-025 u-top-0 u-w-full"
                    style={style}/>
                  <div className="look-ai__overlay-login absolute u-left-0 u-w-full"/>
                </Fragment>
              ) : null}
            </div>
          )
        })}
      </div>
      {viewAllVisible ? (
        <div className="flex flex--center flex--end">
          <span className={"cursor-pointer bold color-active_text hover:color-secondary_active_hover"
            + (someResultExist ? "" : "opacity-0 visibility-hidden")}
                onClick={() => onGeneratedImageClick()}>
            <FormattedMessage id="grohe.feature.viewAll"/>
          </span>
        </div>
      ) : null}
    </div>
  )
};

const mapStateToProps = (store) => {
  const {aiResults} = store.aiState;
  const {isMobile} = store.serverState;

  return {
    aiResults,
    isMobile,
  };
};

const mapDispatchToProps = {
  setLookAiImageOpened,
  setAIResults,
};

export default connect(mapStateToProps, mapDispatchToProps)(LookAIPopupGeneratedImages)
